module.exports = __webpack_public_path__ + "img/联系我们备份.8b97f1f2.jpg";